import styled from 'styled-components'
export const Backdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: ${({ theme }) => theme.app.backdropStyle};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
`

export const ModalStyle = styled.div`
    background: ${({ theme }) => theme.app.background};
    color: ${({ theme }) => theme.app.text};
    border-radius: 20px;
    padding: 24px 2vw 2vh 5vw;
    width: 75vw;
    box-shadow: 0 4px 32px rgba(0, 0, 0, 0.2);
    text-align: start;
    border: 1px solid #cccccc;
`

export const titleStyle = {
    fontWeight: 400,
    margin: '0 0 2vh 0',
    fontSize: '24px',
    lineHeight: '20px',
    color: `${({ theme }) => theme.app.text}`
}

export const buttonStyle = {
    padding: '6px 24px',
    // background: '#333',
    color: '#00bfff',
    border: 'none',
    fontWeight: 600,
    fontSize: '1rem',
    cursor: 'pointer'
}
